/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Bulk_Favorite_ButtonInputs */



/**
* | output |
* | --- |
* | "Add to favorites" |
*
* @param {Projects_Bulk_Favorite_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const projects_bulk_favorite_button = /** @type {((inputs?: Projects_Bulk_Favorite_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Bulk_Favorite_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zu Favoriten hinzufügen")
	return /** @type {LocalizedString} */ ("Add to favorites")
});